import { ServiceVariation } from "@/services/backend/omni/servicevariation/types/service-variation";
import { DocumentKind } from "@bitory-gmbh/bsm";
import { UUID } from "@bitory-gmbh/nidavellir";
import { Position } from "@/services/backend/omni/position/types/position";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";

/** Mirrors `scopeofwork.ScopeOfWork`, backend/core/omni/domain/scopeofwork/scope_of_work.go. */
export type ScopeOfWork = {
  id: UUID;
  createdAt: string;
  updatedAt: string;
  ownerDocumentId: UUID;
  ownerDocumentKind: DocumentKind;
  ownerServiceKind: GSMServiceKind;
  serviceObjectId: string;
  serviceVariation: ServiceVariation;
  title: string;
  subtitle: string;
  text: string;
  positions: Position[];
};

/** Mirrors `scopeofwork.Patch`, backend/core/omni/domain/scopeofwork/scope_of_work.go. */
export type ScopeOfWorkPatch = {
  serviceObjectId?: string;
  serviceVariation?: ServiceVariation;
  title?: string;
  subtitle?: string;
  text?: string;
};

/**
 * patchScopeOfWork returns the scope of work with the fields set on patch.
 * A patched service object is set on all positions as well.
 */
export function patchScopeOfWork(
  scopeOfWork: ScopeOfWork,
  patch: ScopeOfWorkPatch,
): ScopeOfWork {
  const serviceObjectId = patch.serviceObjectId ?? scopeOfWork.serviceObjectId;
  return {
    ...scopeOfWork,
    serviceObjectId,
    positions:
      patch.serviceObjectId === undefined
        ? scopeOfWork.positions
        : scopeOfWork.positions.map((p) => ({ ...p, serviceObjectId })),
    serviceVariation: patch.serviceVariation ?? scopeOfWork.serviceVariation,
    title: patch.title ?? scopeOfWork.title,
    subtitle: patch.subtitle ?? scopeOfWork.subtitle,
    text: patch.text ?? scopeOfWork.text,
  };
}
